import React, { useRef, useState, useCallback, useEffect } from "react";
import "../../../../styles/styles.css";
import image from "../../../../assets/images/card-background.jpg";
import Cards from "./Cards";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import back from "../../../../assets/icons/back-arrow.svg";

const vehicleData = [
  {
    image,
    title: "Trucks",
    description:
      "Booking a truck with ZOWO is easy and fast. Find drivers who arrive on time, charge fairly, and respect your delivery schedule.",
  },
  {
    image,
    title: "Trailer",
    description:
      "Transporting bulky or oversized items? ZOWO connects you with verified trailer drivers - secure handling, predictable pricing, and reliable service.",
  },
  {
    image,
    title: "Chiller",
    description:
      "Fresh or frozen goods like dairy, frozen meals, or medicines? ZOWO gets them delivered safely, at the right temp, and without the risk of spoilage.",
  },
  {
    image,
    title: "Fork Lifter",
    description:
      "Need help lifting heavy pallets or materials? ZOWO connects you with verified forklift operators who get the job done right, safely, at a fair price.",
  },
  {
    image,
    title: "Cranes",
    description:
      "Need to lift something heavy? ZOWO connects you with crane operators who deliver safe, reliable service at fair prices.",
  },
  {
    image,
    title: "Specialty",
    description:
      "When your cargo is one of a kind (oversized or fragile), ZOWO connects you with expert drivers and specialty vehicles that treat your load right.",
  },
  {
    image,
    title: "Recovery",
    description:
      "Need a tow or roadside help? ZOWO’s recovery vehicles offer quick, fair, and efficient service to get you back on track fast.",
  },
];

const Card = () => {
  const [textIndex, setTextIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  const swiperRef = useRef(null);

  const triggerAnimation = () => {
    setAnimate(true);
    setTimeout(() => setAnimate(false), 1000);
  };

  const handleCardClick = useCallback((index) => {
    // triggerAnimation();
    // if (swiperRef.current) {
    //   swiperRef.current.slideToLoop(index,1000);
    // }
  }, []);

  const backButton = () => {
    if (swiperRef.current && textIndex >= 0) {
      swiperRef.current.slideToLoop(textIndex-1,1000);
      triggerAnimation();
    }
  };

  const handleSlideChange=(swipe)=>{
    setTimeout(()=>{
      setTextIndex(swipe?.realIndex);
    },500)
  }
  useEffect(() => {
    // Optional: Trigger animation on mount
    triggerAnimation();
  }, [,textIndex]);

  return (
    <div className="card-container">
      <div className="vehicle-details">
        <span className={`vehicle-heading ${animate ? "animate" : ""}`}>
          {vehicleData[textIndex]?.title}
        </span>
        <span className={`vehicle-description ${animate ? "animate" : ""}`}>
          {vehicleData[textIndex]?.description}
        </span>
        <button className="explore-button">Explore More</button>
      </div>

      {textIndex > 0 ? (
        <button className="arrow-container" onClick={backButton}>
          <img src={back} className="back-arrow" alt="Back" />
        </button>
      ) : (
        <div className="arrow-container" />
      )}

      <div
        className="vehicle-card"
        style={{ marginLeft: textIndex === 0 ? 100 : 0 }}
      >
        <Swiper
          className="swiper-vehicles-card"
          modules={[Autoplay]}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          spaceBetween={20}
          slidesPerView={window.innerWidth>700?3:window.innerWidth>580?2:1}
          loop
          allowTouchMove={true}
          slideToClickedSlide
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          onSlideChange={handleSlideChange}
        >
          {vehicleData.map((item, index) => (
            <SwiperSlide key={index}>
              <Cards
                index={index}
                isActive={index === textIndex}
                image={item.image}
                title={item.title}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Card;
